"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.curriedRecordTimers = exports.curriedRecordCounters = exports.recordTimers = exports.recordCounters = void 0;
const config_1 = __importDefault(require("next/config"));
const metrics_service_1 = require("../metrics-service");
const metricsService = (0, metrics_service_1.isomorphicMetricsService)();
const oneBoxMetricService = (0, metrics_service_1.isomorphicMetricsService)(true);
const recordCounters = (events) => __awaiter(void 0, void 0, void 0, function* () {
    let emitMetricsP = events.map((event) => {
        return metricsService.recordCounter(event);
    });
    if (isOneBox()) {
        const oneBoxEmitMetricsPromise = events.map((event) => {
            return oneBoxMetricService.recordCounter(event);
        });
        emitMetricsP = [...emitMetricsP, ...oneBoxEmitMetricsPromise];
    }
    yield Promise.all(emitMetricsP);
});
exports.recordCounters = recordCounters;
const recordTimers = (events) => __awaiter(void 0, void 0, void 0, function* () {
    let emitMetricsP = events.map((event) => {
        return metricsService.recordTimer(event);
    });
    if (isOneBox()) {
        const oneBoxEmitMetricsPromise = events.map((event) => {
            return oneBoxMetricService.recordTimer(event);
        });
        emitMetricsP = [...emitMetricsP, ...oneBoxEmitMetricsPromise];
    }
    yield Promise.all(emitMetricsP);
});
exports.recordTimers = recordTimers;
const curriedRecordCounters = () => (events) => {
    return (0, exports.recordCounters)(events);
};
exports.curriedRecordCounters = curriedRecordCounters;
const curriedRecordTimers = () => (events) => {
    return (0, exports.recordTimers)(events);
};
exports.curriedRecordTimers = curriedRecordTimers;
const isOneBox = () => {
    const config = (0, config_1.default)();
    return (config === null || config === void 0 ? void 0 : config.publicRuntimeConfig) ? config === null || config === void 0 ? void 0 : config.publicRuntimeConfig.isOneBox : false;
};
